export const RadioButton = ({
    label,
    checked,
    onChange,
    isSquared = false,
    white = false,
}: {
    label?: string;
    checked: boolean;
    onChange: () => void;
    isSquared?: boolean;
    white?: boolean;
}) => {
    return (
        <button
            onClick={onChange}
            className="flex items-center gap-2 text-xl font-bold text-black"
        >
            <div
                className={`size-4 xl:size-6 ${
                    white ? "border-white" : "border-blue-medium"
                } border xl:border-2 ${
                    isSquared ? "" : "rounded-full"
                } relative box-border outline-none`}
                onChange={onChange}
            >
                <div
                    className={`absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 outline-none size-2.5 xl:size-[0.85rem] ${
                        isSquared ? "" : "rounded-full"
                    } ${white ? "bg-white" : "bg-blue-dark"} ${
                        checked ? "" : "hidden"
                    }`}
                ></div>
            </div>
            {label}
        </button>
    );
};

export default RadioButton;
